'use strict';

var _redux = require('redux');

var _emptyReducer = require('./emptyReducer.js');

var _emptyReducer2 = _interopRequireDefault(_emptyReducer);

var _payloadReducer = require('./payloadReducer.js');

var _payloadReducer2 = _interopRequireDefault(_payloadReducer);

var _alertsReducer = require('./alertsReducer.js');

var _alertsReducer2 = _interopRequireDefault(_alertsReducer);

var _activeProviderReducer = require('./activeProviderReducer.js');

var _activeProviderReducer2 = _interopRequireDefault(_activeProviderReducer);

var _helpReducer = require('./helpReducer.js');

var _helpReducer2 = _interopRequireDefault(_helpReducer);

var _actionsTypeConsts = require('./actionsTypeConsts.js');

var _actionsTypeConsts2 = _interopRequireDefault(_actionsTypeConsts);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _redux.combineReducers)({
  providers: _emptyReducer2.default,
  activeProviderId: _activeProviderReducer2.default,
  alerts: _alertsReducer2.default,
  originalProviderId: (0, _payloadReducer2.default)(_actionsTypeConsts2.default.setSelectedProvider, null),
  helpData: _helpReducer2.default,
  hasProviderBeenSet: function hasProviderBeenSet() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    var type = action.type;

    switch (type) {
      case _actionsTypeConsts2.default.providerSuccessfullyChanged:
        state = true;
        break;

      default:
        break;
    }
    return state;
  },
  routing: _reactRouterRedux.routerReducer
});